export default abstract class AppError extends Error {
  abstract name: string
  constructor(message?: string, options?: { cause?: { code: string; values: unknown } }) {
    super(message, options)
  }
}
